<template>
  <div class="p-y-1 p-x-1 bg-l1 corner-3 small flex" :class="size">
    <button v-for="btn in buttons" :key="btn.text" :class="`btn small ${btn.selected ? 'secondary' : 'tertiary'}`" @click="btn.onClick">
      <i :class="`icon icon-${btn.icon}`"></i>
      <span>{{ btn.text }}</span>
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
  export default {
      name: 'ButtonGroup',
      props: {
          buttons: { // [{ icon: String, text: String, onClick: Function, selected: Boolean }]
            type: Array,
            required: false,
            validator: (buttons) => buttons.reduce((acc, btn) => acc && btn.icon && btn.text && btn.onClick && typeof btn.selected === 'boolean', true),
          },
          theme: {
            type: String,
            required: false,
            default: 'default',
            validator(value) {
                return ['default', 'brand', 'main'].includes(value);
            }
          },
          size: {
            type: String,
            required: false,
            default: '',
            validator(value) {
                return ['small', '', 'large'].includes(value);
            }
          },
      },
      data() {
        return {
            showTip: false,
        };
      },
      computed:{
        ...mapGetters('glb', ['glb','getSplit']),
      },
      methods:{
      },
      mounted(){
      }
  };
</script>